export default {
  checkboxField: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',

    width: '100%',
    div: {
      width: '20px',
    },
  },
  topWrapper: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'space-between',
    marginBottom: '20px',
    label: {
      justifyContent: 'center',
    },
  },
  image: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    width: '150px',
    height: '90px',
  },
  order: {
    borderRadius: '8px',
    width: '24px',
    height: '24px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: (theme) => theme.palette.blues.primaryBlue,
    backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
  },
  edit: {
    cursor: 'pointer',
    width: '20px',
  },
  delete: {
    cursor: 'pointer',
    width: '20px',
    color: (theme) => theme.palette.reds.codingRed400,
  },
};
